const CAMPOS_FOTO_PRESTADOR = [
  "foto",
  "Foto",
  "fotoWeb",
  "FotoWeb",
  "imagen",
  "Imagen",
  "imagenWeb",
  "ImagenWeb",
  "fotoBase64",
  "FotoBase64",
  "imagenBase64",
  "ImagenBase64",
];

export const obtenerFotoPrestador = (prestador) => {
  if (!prestador || typeof prestador !== "object") {
    return "";
  }

  const fotoRaw = CAMPOS_FOTO_PRESTADOR.find(
    (campo) => typeof prestador[campo] === "string" && prestador[campo].trim(),
  );

  if (!fotoRaw) {
    return "";
  }

  const fotoNormalizada = prestador[fotoRaw].trim();

  if (!fotoNormalizada) {
    return "";
  }

  if (
    fotoNormalizada.startsWith("data:") ||
    fotoNormalizada.startsWith("http://") ||
    fotoNormalizada.startsWith("https://")
  ) {
    return fotoNormalizada;
  }

  return `data:image/jpeg;base64,${fotoNormalizada}`;
};
